import { useEffect } from 'react';
import { createFileRoute, Outlet, useParams } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { ErrorPage } from '../components/error/ErrorPage';
import { isSupportedLocale } from '../utils/i18n';

function LocaleLayout() {
  const { locale } = useParams({ from: '/$locale' });
  const { i18n } = useTranslation();



  // Sync URL locale with i18n language
  useEffect(() => {
    if (locale && locale !== i18n.language) {
      i18n.changeLanguage(locale);
    }
  }, [locale, i18n]);

  // Check if locale is supported
  if (!isSupportedLocale(locale)) {
    return <ErrorPage statusCode={404} />;
  }

  return <Outlet />;
}

function LocaleNotFoundComponent() {
  return (
    <ErrorPage statusCode={404} showHomeButton={true} showRetryButton={false} />
  );
}

export const Route = createFileRoute('/$locale')({
  ssr: 'data-only',
  component: LocaleLayout,
  notFoundComponent: LocaleNotFoundComponent,
  validateSearch: () => ({}),
});
